import { makeStyles } from '@material-ui/core/styles';
import stock from './img/stock-photo.jpg';
import tealIcon from './img/teal-icon.svg';


const globalUseStyles = makeStyles((theme) => ({
/* Navigation bar */
active: {
  color: 'white',
  textDecoration: 'underline',
},

back:{
    backgroundColor:'#555263',
    paddingBottom: 30,
    borderBottom: 1,
     [theme.breakpoints.down('md')]: {
    paddingTop: 0,
    paddingBottom:0,
  },
},

utilityNavDisplay: {
  display: `flex`,
  justifyContent: 'flex-end',
},

navDisplayFlex: {
  display: `inline-flex`,
  float: 'right',
  justifyContent: `space-between`,
},

navLinkText: {
  textDecoration: `none`,
  textTransform: 'uppercase',
  fontWeight: 800,
  color: `white`,
  fontSize: 16,
},

utilityText: {
  textDecoration: `none`,
  fontWeight: 400,
  fontSize: 14,
  color: 'white',
  '&:hover': {
    textDecoration: 'underline',
 },
},

utilityNav: {
  fontWeight: 600,
  fontSize: 12,
  width: 'fit-content',
  color: 'white',
  '&:hover': {
    textDecoration: 'underline',
 },

},

hamburgerMenu: {
  fontSize: 50, 
  color: 'white',
},

mobileNav: {
  textTransform: 'uppercase',
  fontWeight: 700,
  color: '#555263',
},


mobileUtility: {
  fontWeight: 700,
  color: '#555263',
  fontSize: 14,
},

navMargin: {
  paddingLeft: 50,
  paddingRight: 50,
  margin: 0,
  [theme.breakpoints.down('md')]: {
    paddingTop: 0,
    paddingBottom:0,
  },
  [theme.breakpoints.down('sm')]: {
    paddingLeft: 0,
    paddingRight: 0,
  },
},

/* Footer */
footerSocialList: {
  display: 'inline',
  paddingLeft: 10,

},

footerNavList: {
  display: 'block',
  paddingBottom:10,
  paddingLeft: 10,
  [theme.breakpoints.up('lg')]: {
      display: 'inline',
  },
},

footerContainer: {
  paddingTop:50,
  paddingBottom:20,
    [theme.breakpoints.up('lg')]: {
    paddingBottom: 30,
    paddingTop: 30,
    },
 },


footerNavListSm: {
  display: 'block',
  fontSize: 14,
  paddingBottom:10,
  paddingLeft: 10,
  [theme.breakpoints.up('lg')]: {
      display: 'inline',
  },
},

footerList: {
  display: 'flex',
  flexDirection: 'row',
  padding: 0,
  justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      display: 'block',
  },
},

footerListItem: {
  justifyContent: 'flex-end',
  paddingLeft: 20,
  paddingRight: 0,
  textAlign: 'right',
  width: 'fit-content',
  [theme.breakpoints.down('md')]: {
      margin: '0 auto',
      textAlign: 'center',
      padding: 10,
  },
},

footerLinkText: {
  fontSize: 14,
  color: 'white',
  fontWeight: 700,
},


footerNavUl: {
  listStyleType: 'none',
  padding:0,
  margin:20,
  [theme.breakpoints.up('lg')]: {
      margin: 0,
  },
},

footerSeparator: {
  borderTop: '1px solid #555', 
  marginTop: 10, 
  paddingTop: 10,
  [theme.breakpoints.up('lg')]: {
    border: 'none',
    marginTop: 0,
    paddingTop: 0,
  },
},

/* General Styles */  

fullWidth: {
  width: '100%',
  height: '100%',
},


noPadding: {
  padding: 0,
},

noPaddingSide: {
  paddingLeft: 0,
  paddingRight: 0,
  marginLeft: 0,
  marginRight: 0,
},


noMargin: {
  margin: 0,
},

noMarginBold: {
  marginBottom: 0,
  fontWeight: 700,
},
  
center: {
  display: 'flex',
  margin: '0 auto',
},

noPaddingNoMargin: {
  margin: '0 auto',
  padding: 0,
},

centerButton: {
  display: 'flex',
  margin: '0 auto',
  width: 'fit-content',
},

selfCentered: {
  alignSelf: 'center',
},

centerImage: {
  maxWidth: '100%',
  height: 'auto',
  display: 'flex',
  margin: '0px auto',
},

flexCenter: {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
},

hoverStyle: {
  '&:hover':{
      textDecoration: 'underline',
      background: 'transparent',
  },
},


/* Tags */

tagYellow: {
  paddingLeft: 10,
  paddingRight: 10,
  paddingTop: 10,
  paddingBottom: 10,
  marginRight: 10,
  marginBottom: 10,
  display: 'inline-flex',
  backgroundColor: '#F8F3DF',
  color: '#555263',
  [theme.breakpoints.down('md')]: {
    marginBottom: 20,
  },
},


/* Buttons */
   buttonFlex: {
     float: 'right',
     alignSelf: 'flex-end',
   },

   primaryButton: {
    backgroundColor: '#fff',
    color: '#B64C4C',
    border: '1px solid #B64C4C',
    
    '&:hover': {
      backgroundColor: '#B64C4C',
      color: '#fff',
      },
    },


   primaryButtonCentered: {
    backgroundColor: '#fff',
    color: '#B64C4C',
    border: '1px solid #B64C4C',
    display: 'flex',
    margin: '0 auto',
    width: 'fit-content',
    '&:hover': {
      backgroundColor: '#B64C4C',
      color: '#fff',
      },
    },

   secondaryButton: {
    backgroundColor: 'transparent',
    color: '#fff',
    border: '1px solid #fff',
    margin: 0,

    '&:hover': {
      backgroundColor: '#fff',
      color: '#B64C4C',
      },
    },


   secondaryButtonCentered: {
    backgroundColor: 'transparent',
    color: '#fff',
    border: '1px solid #fff',
    display: 'flex',
    margin: '0 auto',
    width: 'fit-content',
    '&:hover': {
      backgroundColor: '#fff',
      color: '#B64C4C',
      },
    },

  redButton:{
    color:'red',
    background:'#fff',
    border:'1px solid red',
    '&:hover':{
      background:'red',
      color:'#fff'
    }
  },



/* Boxes */
  
tealBox: {
  backgroundColor: '#D8F6EF',
  borderRadius: 20,
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  minHeight: 300,
},

  longBox: {
    backgroundColor: '#555263',
    color: '#ffffff',
    minHeight:300,
    padding: 20,
    borderRadius: 20,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
   },

   normalBox: {
    color: '#555263',
    backgroundColor: '#B7D8DF',
    minHeight: 300,
    padding: 20,
    borderRadius: 20,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    cursor: 'pointer',
    '&:hover':{
      textDecoration: 'underline',
      color: '#fff',
      background: '#555263',
  },
   },
 
   normalBoxBack: {
    color: '#555263',
    backgroundColor: '#B7D8DF',
    minHeight: 300,
    padding: 10,
    borderRadius: 20,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    cursor: 'pointer',
   },
 
  boxTest: {
    border: '1px solid black',
    height: '100%',
  },
  
  boxTest2: {
    height: '100%',
  },

/* Lists */
  listItemText:{
    fontWeight: 700,
    fontSize: 16,
  },

/* Containers and Spacing */
topBottomSpacing: {
  paddingTop: 20,
  paddingBottom: 20,
},

topBottomSpacingMb: {
  paddingTop: 0,
  paddingBottom: 20,
  [theme.breakpoints.down('sm')]: {
    paddingTop: 20,
    paddingBottom:20,
  },
},

bottomSpacing: {
  paddingBottom: 50,
},

containerSmall: {
  width: "80%",
  margin: "0 auto",
  maxWidth: '1600px',
  [theme.breakpoints.down('md')]: {
    width: '88%',
     },
},

containerCarouselSmall: {
  width: "80%",
  margin: "0 auto",
  maxWidth: '1600px',
  [theme.breakpoints.down('md')]: {
    width: '80%',
     },
},


iconSpacing: {
  padding:0,
  margin: 0,
  [theme.breakpoints.down('md')]: {
    paddingBottom: 5,
    alignSelf: 'center',
    marginTop: 5,
     },
},


containerTopPaddingSm: {
  paddingTop: 50,
  paddingBottom: 0,
    paddingLeft: 0,
  paddingRight: 0,
  [theme.breakpoints.down('md')]: {
      paddingTop: 20,
  },
},

containerTopPadding: {
  paddingTop: 100,
  paddingBottom: 0,
    paddingLeft: 0,
  paddingRight: 0,
  [theme.breakpoints.down('md')]: {
      paddingTop: 50,
  },
},

containerTopPaddingLg: {
  paddingTop: 150,
  paddingBottom: 0,
    paddingLeft: 0,
  paddingRight: 0,
  [theme.breakpoints.down('md')]: {
      paddingTop: 150,
  },
  [theme.breakpoints.down('sm')]: {
    paddingTop: 50,
},
},

containerBottomPadding: {
  paddingTop: 0,
  paddingBottom: 100,
    paddingLeft: 0,
  paddingRight: 0,
  [theme.breakpoints.down('md')]: {
      paddingBottom: 50,
  },
},

containerVertPadding: {
  paddingTop: 150,
  paddingBottom: 150,
    paddingLeft: 0,
  paddingRight: 0,
  [theme.breakpoints.down('md')]: {
    paddingTop: 80,
    paddingBottom: 80,
  },
},

containerVertPaddingSm: {
  paddingTop: 50,
  paddingBottom: 50,
  paddingLeft: 0,
  paddingRight: 0,
},

containerVertPaddingLg: {
  paddingTop: 200,
  paddingBottom: 200,
  paddingLeft: 0,
  paddingRight: 0,
  [theme.breakpoints.down('md')]: {
    paddingTop: 140,
    paddingBottom: 140,
  },
},

cardStyle: {
  paddingTop:8,
  paddingBottom:8,
    [theme.breakpoints.down('sm')]: {
      marginTop: 30,
    },
  },

  cardCarouselStyle: {
    paddingTop:8,
    paddingBottom:8,
      [theme.breakpoints.down('sm')]: {
        marginTop: 30,
        paddingRight: 20,
        paddingLeft: 15,
      },
    },

cardStyleLeft: {
  color: 'white',
  textAlign: "center",
  margin: '0 auto',
    [theme.breakpoints.up('lg')]: {
      textAlign: "left",
    },
  },
  
cardStyleRight: {
  color: 'white',
  textAlign: "center",
    [theme.breakpoints.up('lg')]: {
      textAlign: "right",
    },
  },


  cardMargin: {
    marginBottom: 16,
  },
  
  textBlock: {
    paddingLeft: 40,
    [theme.breakpoints.down('sm')]: {
      paddingTop: 25,
      paddingLeft: 0,
       },
  },
  
  textBlockBelow: {
    paddingTop: 40,
    [theme.breakpoints.down('sm')]: {
      paddingTop: 25,
      paddingLeft: 0,
       },
  },
  
  textBlockBelowSm: {
    paddingTop: 30,
    [theme.breakpoints.down('sm')]: {
      paddingTop: 25,
      paddingLeft: 0,
       },
  },
  
  

innerStyleTop: {
  paddingTop:20,
  paddingBottom:20,
},

clientsContainer: {
  paddingTop:50,
  paddingBottom:60,
    [theme.breakpoints.up('md')]: {
      paddingBottom: 100,
      paddingTop: 150,
    },
},

featuredContainer: {
  paddingTop: 150,
  paddingBottom: 150,
  minHeight: 550,
  paddingLeft: 0,
  paddingRight: 0,
  backgroundImage:`url(${tealIcon})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: '20%',
  backgroundPosition: '90% 40px',
  display: 'flex',
  [theme.breakpoints.down('xl')]: {
    backgroundPosition: '90% 50px',
  },
  [theme.breakpoints.down('lg')]: {
    backgroundPosition: '90% 60px',
  },
  [theme.breakpoints.down('md')]: {
    backgroundPosition: '90% 50%',
  },
  [theme.breakpoints.down('sm')]: {
    backgroundPosition: '90% 50%',
    minHeight: 50,
    paddingTop: 100,
    paddingBottom: 100,
    backgroundSize: '35%',
  },
  [theme.breakpoints.down('xs')]: {
    backgroundSize: '50%',
    paddingTop: 50,
    paddingBottom: 50,
  },
},

standardContainer: {
  paddingTop: 150,
  paddingBottom: 150,
  paddingLeft: 0,
  paddingRight: 0,
  [theme.breakpoints.down('sm')]: {
    paddingTop: 50,
    paddingBottom: 50,
  },
},


cardInner: {
  paddingLeft: 30,
  paddingRight: 20,
  paddingTop: 30,
  paddingBottom: 30,
  [theme.breakpoints.down('sm')]: {
    paddingLeft: 20,
    paddingRight: 20,
     },
},

containerInner: {
  maxWidth: '80%',
  margin: '0 auto',
  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
     },
},

paddingTop: {
  paddingTop: 20,
  [theme.breakpoints.down('md')]: {
    paddingTop: 0,
  },
},


cardStyleSmall: {
  [theme.breakpoints.down('sm')]: {
    display: "none",
      },
},


connectContainer: {
  paddingTop:50,
  paddingBottom:50,
    [theme.breakpoints.up('md')]: {
  paddingBottom: 100,
  paddingTop: 150,
    },
 },

innerStyle: {
  paddingTop:50,
  paddingBottom:20,
    [theme.breakpoints.up('md')]: {
  paddingBottom: 100,
  paddingTop: 150,
    },
 },

/* Text */
   typSpacing: {
    marginBottom: 16,
  },

  typSpacingBold: {
    marginBottom: 16,
    fontWeight: 700,
  },

  bold: {
    fontWeight: 700,
  },

/* Images */

imageTreatment: {
  borderRadius: 20,
  width: '100%',
  },  
thumbImg: {
    width: '100%',
    borderRadius: 20,
    marginBottom: 20,
  },

  clientImg: {
    padding: 20,
  },

  stockImg: {
    backgroundImage:`url(${stock})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight:400,
    borderRadius: 30,
    padding: 0,
  },
  
  imgStyle: {
    margin: "0 auto",
    display: "flex",
    paddingTop: "20px",
    paddingBottom: "20px",
  },
    

/* Links */
  linkStyle: {
    marginBottom: 16,
    fontWeight: 600,
    display: 'flex',
  },

  linkStyleArrow: {
    marginBottom: 16,
    fontWeight: 600,
    display: 'flex',
  },


  linkStyleArrowCentered: {
    marginBottom: 16,
    paddingTop: 6,
    fontWeight: 600,
    display: 'flex',
    justifyContent: 'center',
  },

  arrowForward: {
    color:'#B64C4C',
    paddingLeft: 5,
  },

/* Contact Boxes */
iconSuccess: {
  fontSize: '3rem',
  color: '#555263',
  padding: '10px 0 30px 0',
},

dialogBoxSuccess: {
  margin: '0 auto',
  textAlign: 'center',
}

}));

export default globalUseStyles